"use client";

import { iCustomTemplateBlockData } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

interface CustomTemplateBlockSectionProps extends iCustomTemplateBlockData {}

export function CustomTemplateBlockSection({ html }: CustomTemplateBlockSectionProps) {
  if (!html?.trim()) {
    return null;
  }

  return (
    <div
      className="quote-custom-template-block"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
